import React, { useState, useEffect, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import DatePicker from 'react-datepicker'
import TextInput from '../../../components/TextInput'
import dayjs from 'dayjs'

import { req } from '../../../util'
import { toggleLoading, toast } from '../../../redux/actions'

export const SyncReport = () => {

    const dispatch = useDispatch()
    const [from, setFrom] = useState(new Date())
    const [to, setTo] = useState(new Date())
    const [carID, setCarID] = useState("")
    const [branch, setBranch] = useState("")
    const [report, setReport] = useState([])


    const getReport = useCallback(async () => {
        let fromDateFormat = dayjs(from || new Date()).format("YYYY-MM-DD")
        let toDateFormat = dayjs(to || new Date()).format("YYYY-MM-DD")
        try {
            dispatch(toggleLoading())
            let { success, data, msg } = await req("GET", `car/report/access?from=${fromDateFormat}&to=${toDateFormat}&carID=${carID}&branch=${branch}`)
            if (success) setReport(data)
            dispatch(toggleLoading())
            if (!success) dispatch(toast({ msg }))
        } catch (err) {
            dispatch(toggleLoading())
            dispatch(toast({ msg: 'لا يمكن الوصول الى الخادم', msgType: 0 }))
        }
    }, [from, to, branch, carID])



    useEffect(() => {
        getReport()
    }, [getReport])


    return (
        <div className="container mx-auto p-2 m-2">
            <div className="text-center font-normal text-lg m-2">تقرير العمليات</div>
            <div className="mx-auto flex justify-around items-center p-2">
                <div className="w-1/3">
                    <DatePicker selected={from} onChange={date => setFrom(date)} className="bg-gray-200 p-1 w-full" placeholderText="من" />
                </div>
                <div className="w-1/3">
                    <DatePicker selected={to} onChange={d => setTo(d)} className="bg-gray-200 p-1 w-full" placeholderText="الى" />
                </div>
            </div>
            <div className="mx-auto flex justify-around items-center p-2">
                <div className="w-1/3">
                    <span className="font-semibold px-1 text-gray-800">معرف الحالة</span>
                    <TextInput
                        value={carID}
                        onChange={evt => setCarID(evt.target.value)}
                    />
                </div>
                <div className="w-1/3">
                    <span className="font-semibold px-1 text-gray-800">رقم الفرع</span>
                    <TextInput
                        value={branch}
                        onChange={evt => setBranch(evt.target.value)}
                    />
                </div>
            </div>
            <div className="w-full mt-2 mx-2">
                <div className="border-2 rounded border-grey-200">
                    <table className="text-left w-full">
                        <thead className="flex text-right font-semibold text-gray-600 w-full ">
                            <tr className="flex text-center w-full bg-grey-050 border-b-2 items-center border-grey-200">
                                <th className="p-2 w-8">ت</th>
                                <th className="p-2 w-3/12">رقم الفرع</th>
                                <th className="p-2 w-2/12">معرف الحالة</th>
                                <th className="p-2 w-2/12">اسم المستخدم</th>
                                <th className="p-2 w-2/12">المصدر</th>
                                <th className="p-2 w-2/12">التاريخ والوقت</th>
                            </tr>
                        </thead>
                        <tbody className="flex flex-col items-center text-md text-right w-full overflow-y-scroll" id="feed">
                            {report.map((r, index) => (
                                <tr key={index} className="flex text-center w-full border-b border-grey-50 text-grey-900 cursor-pointer">
                                    <td className="py-2 px-1 w-8 text-center">
                                        {index + 1}
                                    </td>
                                    <td className="py-2 px-1 w-3/12">
                                        {r.branch}
                                    </td>
                                    <td className="py-2 px-1 w-2/12">
                                        <Link to={`/writeReport?id=${r.carID}`} target="_blank">{r.carID}</Link>
                                    </td>
                                    <td className="py-2 px-1 w-2/12">
                                        {r.created_by}
                                    </td>
                                    <td className="py-2 px-1 w-2/12">
                                        {r.source}
                                    </td>
                                    <td className="py-2 px-1 w-2/12">
                                        {dayjs(r.created_at).format("YYYY-MM-DD hh:mm a")}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
